import { types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { AxiosResponse } from "axios";

const prefixUrl = "/statistics";

export default {
    async year(param: types.statistics.ReqStatistics): Promise<types.statistics.ResStatistics> {
        const res = {} as types.statistics.ResStatistics;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/year", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async counsel(param: types.statistics.ReqStatistics): Promise<types.statistics.ResStatistics> {
        const res = {} as types.statistics.ResStatistics;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/counsel", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async client(param: types.statistics.ReqStatistics): Promise<types.statistics.ResStatistics> {
        const res = {} as types.statistics.ResStatistics;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/client", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async activity(param: types.statistics.ReqStatistics): Promise<types.statistics.ResStatistics> {
        const res = {} as types.statistics.ResStatistics;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/network", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async exportExcel(param: types.statistics.ReqStatisticsForExcel): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post(prefixUrl + "/excel/download", param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },
};
